import { render, staticRenderFns } from "./baseregistnoAction.vue?vue&type=template&id=5da19648&scoped=true"
import script from "./baseregistnoAction.vue?vue&type=script&lang=js"
export * from "./baseregistnoAction.vue?vue&type=script&lang=js"
import style0 from "./baseregistnoAction.vue?vue&type=style&index=0&id=5da19648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da19648",
  null
  
)

export default component.exports